var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-img"},[_c('img',{style:({ width: _vm.imgWidth }),attrs:{"src":_vm.emptyImgUrl,"alt":""}}),_c('span',{},[_vm._v("暂无数据")])])
}
var staticRenderFns = []

export { render, staticRenderFns }